import type { ReactNode } from "react";
import { SvgContainer } from "../Shapes/SvgComponent";

const SIDE_LENGTH = 300;

export function WheelContainer({ children }: { children: ReactNode }) {
    return (
        <SvgContainer width={SIDE_LENGTH} height={SIDE_LENGTH}>
            {children}
        </SvgContainer>
    );
}

export function Wheel() {
    const center = SIDE_LENGTH / 2;
    return (
        <circle
            cx={center}
            cy={center}
            r={SIDE_LENGTH / 2.5}
            className="stroke-compendia-greige"
            strokeWidth={SIDE_LENGTH / 150}
            fill="none"
        />
    );
}

export function YearText({ year }: { year: string }) {
    const radius = SIDE_LENGTH / 2.5;
    const sideLength = SIDE_LENGTH;
    const center = sideLength / 2;

    const topSize = radius / 4;
    const botSize = radius / 6;

    const gap = (topSize + botSize) / 4;

    return (
        <>
            <text
                x={center}
                y={center - gap}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize={topSize}
                fill="white"
            >
                {year}
            </text>
            <text
                x={center}
                y={center + gap}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize={botSize}
                fill="#928DD3"
            >
                HSE&Q
            </text>
        </>
    );
}
